import useNavigateWithScrollSave, { checkIsMenuExpanded } from 'hooks/useNavigateWithScrollSave'
import { useHistory, useParams } from 'react-router-dom'
import { selectLocation } from './menu/filtersSlice'
import { useContext, useEffect, useRef, useState } from 'react'
import { ViewContext } from 'context/ViewContext'
import { selectMapOptions } from './Map/mapSlice'
import { checkIsIos } from 'utils/nativeApp'
import { useSelector } from 'react-redux'
import Options from './Map/Options'
import Filter from './menu/Filter'
import Close from './menu/Close'
import Place from './menu/Place'
import Result from './Result'
import Map from './Map'

const isNativeIosApp = checkIsIos()

const map = <Map />

const View = () => {
  const mobile = useContext(ViewContext)

  const { placeId } = useParams()
  const location = useSelector(selectLocation)
  const { voivodship } = useSelector(selectMapOptions)
  const [expanded, expand] = useState(checkIsMenuExpanded())
  const [fullScreen, setFullScreen] = useState(false)
  const [scrollableMenu, setMenuScrollable] = useState(false)

  const mapRef = useRef(null)
  const menuRef = useRef(null)
  const placeDetailsRef = useRef(null)
  const menuWider = location && voivodship === undefined
  const menuSize = fullScreen ? 2.9 : menuWider ? 21.5 : 17.5

  const { goBack } = useHistory()
  const navigate = useNavigateWithScrollSave(expanded, menuRef)
  const scroll = ref => ref.current?.scrollIntoView({ behavior: 'smooth' })
  const isMobileWithoutPopups = () => mobile && !window.history.state?.state?.popup

  useEffect(() => {
    if (mobile) {
      document.body.style.setProperty('overflow', 'hidden')
      return () => {
        document.body.style.removeProperty('overflow')
      }
    }
  }, [mobile])

  useEffect(() => {
    if (placeId && !expanded) {
      return () => {
        expand(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeId])


  const onTouch = e => {
    const menu = menuRef.current
    if (!menu || !mobile) return

    const initialY = e.touches[0].clientY
    const isAnnouncement = placeId
      ? placeDetailsRef.current?.dataset?.announcement
      : undefined

    const touchMove = e => {
      const currentY = e.touches[0].clientY
      if (
        (initialY - currentY > 50 && !expanded && isAnnouncement !== 'true') ||
        (currentY - initialY > 50 && expanded)
      ) {
        expand(!expanded)
        touchEnd()

      } else if (currentY - initialY > 50 && !expanded && placeId) {
        goBack()
        touchEnd()
      }
    }

    const touchEnd = () => {
      menu.removeEventListener('touchend', touchEnd, false)
      menu.removeEventListener('touchmove', touchMove, false)
    }

    menu.addEventListener('touchend', touchEnd, false)
    menu.addEventListener('touchmove', touchMove, false)
  }

  const scrollMap = e => {
    const halfHeight = window.innerHeight / 2
    const y = e.target.scrollTop

    if (!scrollableMenu && y >= halfHeight) setMenuScrollable(true)
    else if (scrollableMenu && y < halfHeight) setMenuScrollable(false)

    if (!expanded && y > 160) expand(true)
    else if (expanded && y < 20) expand(false)
  }

  const toggleMenu = () => {
    if (menuRef.current && expanded) menuRef.current.scrollTop = 0
    mobile ? expand(!expanded) : scroll(expanded ? mapRef : menuRef)
  }

  const checkIsContentScrolledUp = () => {
    const checkIsSelectedContentScrolledUp = (element) => {
      if (!element) return true
      return element.scrollTop < 1
    }

    if (placeId && !expanded) return true
    const element = placeId ? placeDetailsRef : menuRef
    return checkIsSelectedContentScrolledUp(element.current)
  }

  const menuStyle = {
    mobile: expanded
      ? {
        height: `calc(100 * var(--vh, 1vh) - ${isNativeIosApp ? 4 : 1}em)`,
        maxHeight: `calc(100 * var(--vh, 1vh) - ${isNativeIosApp ? 4 : 1}em)`,
        overflowY: placeId ? 'initial' : 'auto',
      } : placeId
        ? { maxHeight: `calc(var(--vh, 1vh) * 45)` }
        : { maxHeight: `${menuSize}em` },
    desktop: scrollableMenu ? { overflowY: 'auto' } : { overflowY: 'hidden' }
  }

  return (
    <div
      className='maps'
      onScroll={e => !mobile && scrollMap(e)}
      style={{ overflow: mobile ? 'hidden' : 'auto' }}>

      <div
        ref={mapRef}
        className={`maps__main ${fullScreen ? '--full' : menuWider ? '' : '--wider'}`}>

        {map}
        {((mobile && !expanded) || (!mobile && !scrollableMenu)) && !placeId && <Options
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
        />}
      </div>

      <div
        ref={menuRef}
        className={`map__menu${mobile ? ' --mobile' : ''}${(placeId && expanded) ? ' --expanded' : ''}`}
        onTouchStart={e => (isMobileWithoutPopups() && checkIsContentScrolledUp()) && onTouch(e)}
        style={mobile ? menuStyle.mobile : menuStyle.desktop}>

        <Close
          expand={expand}
          placeId={placeId}
          expanded={expanded}
          fullScreen={fullScreen}
          toggleMenu={toggleMenu}
          setFullScreen={setFullScreen}
        />

        {placeId && <Place
          placeId={placeId}
          expanded={expanded}
          placeDetailsRef={placeDetailsRef}
        />}

        <div style={placeId ? { display: 'none' } : undefined}>
          {!expanded && <Filter
            desktop={!mobile}
            navigate={navigate}
          />}
          <Result
            menuRef={menuRef}
            expanded={expanded}
            navigate={navigate}
            show={toggleMenu}
          />
        </div>
      </div>
    </div>
  )
}

export default View